/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the CodeTableType
 *
 * @class CodeTableType
 */
class CodeTableType {
  /**
   * Creates an instance of CodeTableType.
   * @param {*} json
   * @memberof CodeTableType
   */
  constructor(json = null) {
    if (json) {
      // string
      this.tableName = json.tableName;

      // string
      this.value = json.value;

      // string
      this.description = json.description;

      // string
      this.parentCodeTable = json.parentCodeTable;
    }
  }
}

/**
 * Models the ProductDeliveryCase
 *
 * @class ProductDeliveryCase
 */
class ProductDeliveryCase {
  /**
   * Creates an instance of ProductDeliveryCase.
   * @param {*} json
   * @memberof ProductDeliveryCase
   */
  constructor(json = null) {
    if (json) {
      // string
      this.type = json.type;
    }
  }
}

/**
 * Models the Program
 *
 * @class Program
 */
class Program {
  /**
   * Creates an instance of Program.
   * @param {*} json
   * @memberof Program
   */
  constructor(json = null) {
    if (json) {
      // string
      this.type = json.type;
    }
  }
}

/**
 * Models the Case
 *
 * @class Case
 */
class Case {
  /**
   * Creates an instance of Case.
   * @param {*} json
   * @memberof Case
   */
  constructor(json = null) {
    if (json) {
      // string
      this.caseId = json.caseId;

      // object - CodeTableType
      if (json.caseType) {
        this.caseType = new CodeTableType(json.caseType);
      }

      // array - ProductDeliveryCase
      if (json.productDeliveryCases) {
        this.productDeliveryCases = json.productDeliveryCases.map(
          object => new ProductDeliveryCase(object)
        );
      } else if (json.constructor === Array) {
        this.productDeliveryCases = json.map(object => new ProductDeliveryCase(object));
      }

      // array - Program
      if (json.programs) {
        this.programs = json.programs.map(object => new Program(object));
      } else if (json.constructor === Array) {
        this.programs = json.map(object => new Program(object));
      }
    }
  }
}

/**
 * Models the Response
 *
 * @class Response
 */
class Response {
  /**
   * Creates an instance of Response.
   * @param {*} json
   * @memberof Response
   */
  constructor(json = null) {
    if (json) {
      // array - Case
      if (json.data) {
        this.data = json.data.map(object => new Case(object));
      } else if (json.constructor === Array) {
        this.data = json.map(object => new Case(object));
      }
    }
  }
}

export default {
  CodeTableType,

  ProductDeliveryCase,

  Program,

  Case,

  Response,
};
